export const getStatus = (status: number) => {
  switch (status) {
    case 0:
      return '0Ideal'
    case 1:
      return '1Pacote'
    case 2:
      return '2Estoque Máximo'
    case 3:
      return '3Compra Mínima'
    case 4:
      return '4Opção de Compra'
    case 5:
      return '5Sem Estoque'
    case 6:
      return '6Indisponível'
    case 7:
      return '7Compra Mínima > Estoque Máximo'
    case 8:
      return '8Cobertura < Estoque Segurança'
    case 9:
      return '9Compra Desnecessária'
    case 10:
      return '10Estoque Arbitrado'
    case 11:
      return '11Lote Múltiplo'
    case 12:
      return '12Produto Similar'
    case 13:
      return '13Produto Novo'
    case 14:
      return '14Analisar'
    case 15:
      return '15OK'
    case 16:
      return '16Estoque Baixo CD'
    case 17:
      return '17Estoque Mínimo'
    case 18:
      return '18Incremento Estoque'
    default:
      return 'Status não encontrado'
  }
}

export const toCoverLocaleString = (str: number) => {
  return !isFinite(str) ? '&#8734;' : str
}

export const toLocaleString = (str: any) => {
  return str
    ? str.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    : str
}

export const toLocaleString2 = (str: any) => {
  return str ? str.toLocaleString('pt-BR') : str
}

export const toLocaleString3 = (str: any) => {
  return str
    ? str.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })
    : str
}

export const toLocaleString4 = (str: any) => {
  return str
    ? str.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    : str
}

export const removeDecimalPlaces = (value: number) => {
  return Math.trunc(value)
}
export const formatToBRL = (value: number) => {
  return (
    'R$ ' +
    value.toLocaleString('pt-BR', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    })
  )
}
export const formatPercent = (value: number) => {
  value = value * 100
  return value.toFixed(2) + ' %'
}

export const formatPercentOriginal = (value: number) => {
  return value.toFixed(2) + ' %'
}
